import { AlertComponentModule } from '@b2b/common/components/alert';
import { NoticesComponentModule } from '@b2b/common/components/notices';
import { NoticeFactory } from '@b2b/common/factories/notice';
import { parseUrl } from '@b2b/common/filters';
import { ThemesData } from '@b2b/common/resolvers';
import { CustomerFormResponse } from '@b2b/common/services/api/ordersApi/types';
import { ApiService } from '@b2b/common/services/api/types';
import { CustomerService, CustomerServiceModule } from '@b2b/common/services/customer';
import { PermissionsService } from '@b2b/common/services/permissions';
import { ThemesHelperService } from '@b2b/common/services/themesHelper';
import {
  ACMEListResponse,
  ACMEResponse,
  ColumnDef,
  extractACMEPayload,
  TODO,
  UIBModal,
  UIBModalService,
} from '@b2b/types/core';
import { Customer } from '@b2b/types/customer';
import uiRouter, { StateParams, StateService } from '@uirouter/angularjs';
import angular, { IFilterService, IQService, IScope, ITimeoutService } from 'angular';
import {
  CustomersIndividualsListService,
  CustomersIndividualsListServiceModule,
} from '../../list/services/customers-individuals-list.service';
import { rawFiltersSchema } from '../../list/types';
import {
  CustomersIndividualsDetailService,
  CustomersIndividualsDetailServiceModule,
} from '../services/customers-individuals-detail.service';
import { CustomerVM } from '../types';

type CustomerIndividualDetailTab =
  | ''
  | 'addresses'
  | 'memberships'
  | 'attributes'
  | 'solicitationCodes'
  | 'mergeHistory'
  | 'forms';

class CustomersIndividualsDetailController {
  static $inject = [
    '$scope',
    '$q',
    '$filter',
    '$state',
    '$timeout',
    '$uibModal',
    '$stateParams',
    'ApiService',
    'CalendarService',
    'UserPreferencesService',
    'CustomerService',
    'ValidateService',
    'PermissionsService',
    'NoticeFactory',
    'GridStateFactory',
    'GridDefinitionFactory',
    'CustomersIndividualsListService',
    'CustomersIndividualsDetailService',
    'ThemesHelperService',
    'HelpersService',
  ];

  ThemesData?: { data: ACMEResponse<ThemesData> };
  membershipsData = {};

  model = {} as TODO;
  addresses = [] as TODO[];
  memberships = [] as TODO[];
  attributes = {} as TODO;
  solicitationCodes = {} as TODO;
  formsResponsesList = [] as TODO[];
  // TODO: APP-4349 - replace calls needed to get these values with an HTTP cache layer?
  formsResponsesListStatus: 'initial' | 'pending' | 'fulfilled' = 'initial';

  possiblyDuplicateCustomers = [] as Customer[];

  tab: CustomerIndividualDetailTab = '';

  errors = {} as Record<string, TODO>;

  customer = {} as CustomerVM;
  titles: { title: string; name: string }[] = [];

  loading = false;
  initLoading = false;

  isMembershipLoading = false;
  enableCustomerMerge = false;
  isFormsLoading = false;

  customerIdDetails = {
    columns: 1,
    columnWidth: 4,
    data: 'customersIndividualsDetail.model',
    include: [
      'customerSource',
      'customerId',
      'externalCustomerImportId',
      'externalId',
      'externalCustomerId',
      'orgName',
    ],
    mappings: {
      customerId: 'ACME Customer Number',
      externalCustomerImportId: 'External Customer Import ID',
      externalId: 'External ID',
      externalCustomerId: 'External Customer ID',
      orgName: 'Organization',
    },
  };

  customerDetails = {
    columns: 3,
    columnWidth: 4,
    data: 'customersIndividualsDetail.model',
    include: ['prefix', 'firstName', 'middleName', 'lastName', 'email', 'phoneNumber'],
    mappings: {
      prefix: 'Title',
    },
  };

  customerMetaDetails = {
    columns: 2,
    columnWidth: 4,
    data: 'customersIndividualsDetail.model',
    include: ['createdOn', 'createdBy', 'updatedOn', 'updatedBy'],
  };

  attributeGridOptions = {
    pageSize: 15,
    paginate: true,
    useExternalPagination: true,
    useExternalSorting: true,
    multiselect: false,
    showFooter: false,
    columnDefs: [],
  };

  membershipGridOptions = {
    rowHeight: 40,
    useAccessibleGrid: true,
    data: 'customersIndividualsDetail.memberships',
    appScopeProvider: {
      onDataGridPaginate: (newPage, pageSize, sortField, sortDirection) => {
        this.refreshMembershipsGrid();
      },
      onSetAsLatest: (item) => {
        this.onSetAsLatest(item);
      },
      onIdClick: (item) => {
        this.onIdClick(item);
      },
    },
    columnDefs: [
      {
        field: 'id',
        displayName: 'ID',
        onCellNavClick: (row, col) => {
          this.membershipGridOptions.appScopeProvider.onIdClick(row.entity);
        },
        cellTemplate:
          '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a class="clickable" data-ng-click="grid.appScope.onIdClick(row.entity)" role="button"><span class="sr-only">Go to membership </span>{{row.entity.id}}</a></div>',
        visible: true,
      },
      {
        field: 'acmeMembershipNumber',
        displayName: 'ACME Membership Number',
        visible: true,
      },
      {
        field: 'membershipCategory',
        displayName: 'ACME Level',
        visible: true,
      },
      {
        field: 'offeringName',
        displayName: 'Offering Name',
        visible: true,
      },
      {
        field: 'auxiliaryMembership',
        displayName: 'Is Aux',
        visible: false,
      },
      {
        field: 'isGift',
        displayName: 'Is Gift',
        visible: true,
      },
      {
        field: 'membershipStanding',
        displayName: 'Membership Standing',
        visible: true,
      },
      {
        field: 'externalMembershipId',
        displayName: 'External Membership ID',
        visible: false,
      },
      {
        field: 'membershipJoinedDate',
        displayName: 'Joined',
        visible: false,
      },
      {
        field: 'membershipStartDate',
        displayName: 'Start Date',
        visible: true,
      },
      {
        field: 'membershipExpirationDate',
        displayName: 'Expiration Date',
        visible: true,
        sort: {
          direction: 'desc',
        },
      },
      {
        field: 'isLatest',
        displayName: 'Latest',
        visible: true,
      },
    ] as ColumnDef[],
  };

  mergeHistoryGridOptions = {
    rowHeight: 40,
    useAccessibleGrid: true,
    enableSorting: false,
    enableGridMenu: false,
    enablePagination: false,
    showGridFooter: false,
    data: 'customersIndividualsDetail.customer.mergeHistory',
    appScopeProvider: {
      onDataGridPaginate: (newPage, pageSize, sortField, sortDirection) => {
        this.refreshMergeHistoryGrid();
      },
    },
    columnDefs: [
      {
        field: 'customerId',
        displayName: 'ACME Customer Number',
        visible: true,
        enableSorting: false,
      },
      {
        field: 'externalCustomerImportId',
        displayName: 'External Customer Import ID',
        visible: true,
        enableSorting: false,
      },
      {
        field: 'firstName',
        displayName: 'First Name',
        visible: true,
        enableSorting: false,
      },
      {
        field: 'lastName',
        displayName: 'Last Name',
        visible: true,
        enableSorting: false,
      },
      {
        field: 'email',
        displayName: 'Email',
        visible: true,
        enableSorting: false,
      },
    ] as ColumnDef[],
  };

  formsGridOptions = {
    gridState: new this.GridStateFactory(),
    optionsOverride: {
      rowHeight: 40,
      useAccessibleGrid: true,
      data: 'customersIndividualsDetail.formsResponsesList',
      columnDefs: [
        {
          field: 'formCategoryType',
          displayName: 'Type',
          visible: true,
          colId: 'formCategoryType',
          enableSorting: false,
          cellTemplate:
            '<div class="ui-grid-cell-contents"><span class="text-capitalize">{{ row.entity.formCategoryType}}</span></div>',
        },
        {
          field: 'itemName',
          displayName: 'Event Template Name',
          visible: true,
          colId: 'itemName',
          enableSorting: false,
          onCellNavClick: (row, col) => {
            this.formsGridOptions.optionsOverride.appScopeProvider.viewItem(row);
          },
          cellTemplate:
            '<div class="clickable ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.viewItem(row)" role="link"><span class="sr-only">View Event </span>{{ row.entity.itemName }}<span class="sr-only"> Details</span></a></div>',
        },
        {
          field: 'membershipId',
          displayName: 'Membership ID',
          visible: true,
          colId: 'itemName',
          enableSorting: false,
          onCellNavClick: (row, col) => {
            this.formsGridOptions.optionsOverride.appScopeProvider.viewItem(row);
          },
          cellTemplate:
            '<div class="clickable ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.viewItem(row)" role="link"><span class="sr-only">View Membership ID</span> {{ row.entity.membershipId }}<span class="sr-only"> Details</span></a></div>',
        },
        {
          field: 'membershipLevel',
          displayName: 'Membership Level',
          visible: true,
          colId: 'membershipLevel',
          enableSorting: false,
        },
        {
          field: 'membershipOffering',
          displayName: 'Membership Offering',
          visible: false,
          colId: 'membershipOffering',
          enableSorting: false,
        },
        {
          field: 'membershipLifecycle',
          displayName: 'Membership Lifecycle',
          visible: false,
          colId: 'membershipLifecycle',
          enableSorting: false,
        },
        {
          field: 'formName',
          displayName: 'Form Name',
          visible: true,
          colId: 'formName',
          enableSorting: false,
        },
        {
          field: 'formNumber',
          displayName: 'Response Number',
          visible: true,
          colId: 'formNumber',
          enableSorting: false,
        },
      ] as TODO,
      appScopeProvider: {
        onDataGridPaginate: (newPage, pageSize, sortField, sortDirection) => {
          this.refreshFormGrid();
        },
        onGridDoubleClick: (row) => {
          if (this.PermissionsService.check('FORM_RESPONSE_VIEW')) {
            this.$state.go('application.orders.detail.forms.detail', {
              orderId: row.entity.orderId,
              responseId: row.entity.formResponseId,
            });
          }
        },
        viewItem: (row) => {
          const itemId = row.entity.membershipId || row.entity.itemId;
          switch (row.entity.formCategoryType) {
            case 'event':
              this.$state.go('application.programsInstance', { id: itemId });
              break;
            case 'membership':
              this.$state.go('application.membership.detail', { id: itemId });
              break;
            case 'donation':
              break;
            case 'addon':
              break;
            default:
              break;
          }
          return;
        },
      },
    },
  };

  codesGridOptions = {
    pageSize: 15,
    paginate: true,
    useExternalPagination: true,
    useExternalSorting: true,
    multiselect: false,
    showFooter: false,
    columnDefs: [],
  };

  notice = new this.NoticeFactory();

  addressGridDefinition = new this.GridDefinitionFactory();
  addressGridName = this.$state.current.name + '.grid-0';

  membershipGridDefinition = new this.GridDefinitionFactory();
  membershipsGridName = this.$state.current.name + '.grid-1';

  mergeHistoryGridDefinition = new this.GridDefinitionFactory();
  mergeHistoryGridName = this.$state.current.name + '.grid-merge-history';

  formsGridDefinition = new this.GridDefinitionFactory();
  formsGridName = this.$state.current.name + '.grid-3';

  viewId = this.$state.current.name;

  addressGridOptions = {
    rowHeight: 40,
    useAccessibleGrid: true,
    data: 'customersIndividualsDetail.addresses',
    appScopeProvider: {
      onDataGridPaginate: (newPage, pageSize, sortField, sortDirection) => {
        this.refreshAddressesGrid();
      },
      onEditClick: (item) => {
        this.editAddress(item);
      },
    },
    columnDefs: [
      {
        field: 'type',
        displayName: 'Type',
        visible: true,
        enableSorting: false,
      },
      {
        field: 'streetAddress1',
        displayName: 'Address 1',
        visible: true,
        enableSorting: false,
      },
      {
        field: 'streetAddress2',
        displayName: 'Address 2',
        visible: true,
        enableSorting: false,
      },
      {
        field: 'city',
        displayName: 'City',
        visible: true,
        enableSorting: false,
      },
      {
        field: 'state',
        displayName: 'State',
        visible: true,
        enableSorting: false,
      },
      {
        field: 'zipCode',
        displayName: 'ZIP / Postal Code',
        visible: true,
        enableSorting: false,
      },
      {
        field: 'country',
        displayName: 'Country',
        visible: true,
        enableSorting: false,
      },
      {
        field: 'id',
        displayName: 'ID',
        visible: false,
        enableSorting: false,
      },
    ] as ColumnDef[],
  };

  cancelModal = {} as UIBModal<TODO>;

  dateTimeFormat = '';

  constructor(
    private $scope: IScope & { customersIndividuals: TODO; customersIndividualsDetail: TODO },
    private $q: IQService,
    private $filter: IFilterService,
    private $state: StateService,
    private $timeout: ITimeoutService,
    private $uibModal: UIBModalService,
    private $stateParams: StateParams,
    private apiService: ApiService,
    private CalendarService: TODO,
    private UserPreferencesService: TODO,
    private customerService: CustomerService,
    private ValidateService: TODO,
    private PermissionsService: PermissionsService,
    private NoticeFactory: NoticeFactory,
    private GridStateFactory: TODO,
    private GridDefinitionFactory: TODO,
    private customersIndividualsListService: CustomersIndividualsListService,
    private customersIndividualsDetailService: CustomersIndividualsDetailService,
    private themesHelperService: ThemesHelperService,
    private helpersService: TODO
  ) {
    this.$scope.customersIndividualsDetail = this;
  }

  $onInit() {
    if (this.ThemesData && this.ThemesData.data.success) {
      this.themesHelperService.setModel(this.ThemesData.data.payload);
      this.enableCustomerMerge = (this.themesHelperService.getCompany('enableCustomerMerge') as TODO) ?? false;
    }

    if (this.$state.params) {
      this.getCustomer();
    }

    if (this.isEditMode()) {
      this.initEditModeSettings();
    }

    this.addressGridDefinition.init(
      this.addressGridName,
      this.addressGridOptions,
      this.viewId,
      this.$state.current.data.enablePreferences
    );

    this.membershipGridDefinition.init(
      this.membershipsGridName,
      this.membershipGridOptions,
      this.viewId,
      this.$state.current.data.enablePreferences
    );

    this.formsGridDefinition.init(
      this.formsGridName,
      this.formsGridOptions.optionsOverride,
      this.viewId,
      this.$state.current.data.enablePreferences
    );

    this.mergeHistoryGridDefinition.init(this.mergeHistoryGridName, this.mergeHistoryGridOptions, this.viewId, false);

    this.initMembershipGrid();
    this.initFormsGrid();
    this.initHeader({ loading: true });

    this.dateTimeFormat = this.UserPreferencesService.getDateTimeFormat('sortDateTime');
  }

  initHeader(options: { loading: boolean }) {
    this.initLoading = options.loading;

    this.$scope.$emit('Application::contentTitleChange', {
      title: 'Customer Details',
      buttonLeft: {
        label: this.isEditMode() ? 'Cancel' : '< Back',
        action: () => {
          if (this.isEditMode()) {
            this.showCancelModal();
          } else {
            window.history.go(-1);
          }
        },
      },
      buttonRight: this.PermissionsService.check(['CUSTOMERS_UPDATE'])
        ? {
            label: this.isEditMode() ? 'Update' : 'Edit',
            permissions: ['CUSTOMERS_UPDATE'],
            isDisabled: options.loading,
            action: () => {
              if (this.isEditMode()) {
                this.updateCustomer();
              } else {
                this.$state.go(
                  'application.customers.individuals.edit',
                  { id: this.$state.params.id },
                  { location: 'replace' }
                );
              }
            },
          }
        : null,
    });
  }

  initEditModeSettings() {
    this.titles = this.customerService.getTitles();

    Object.assign(this.customerDetails, {
      showEmpty: true,
      templates: {
        prefix: {
          getScope: this.$scope,
          permissions: 'CUSTOMERS_UPDATE',
          template:
            '\n' +
            '<div data-combobox \n' +
            'class="customers-individuals-detail-input"\n' +
            'data-items="customersIndividualsDetail.titles"\n' +
            'data-ng-model="customersIndividualsDetail.customer.selectedTitle"\n' +
            'data-name="customers-individuals-edit-title"\n' +
            'data-readonly="true"\n' +
            'data-append-to-body="true"\n' +
            'label="Title"></div>',
        },
        firstName: {
          getScope: this.$scope,
          permissions: 'CUSTOMERS_UPDATE',
          template:
            '\n' +
            '<div data-input-field-with-label\n' +
            'class="customers-individuals-detail-input"\n' +
            'data-label="First Name"\n' +
            'data-name="customers-individuals-edit-first-name"\n' +
            'data-field-name="customers-individuals-edit-first-name"\n' +
            'type="text"\n' +
            'data-model="customersIndividualsDetail.customer.firstName"\n' +
            'data-required="true"\n' +
            'data-errors="customersIndividualsDetail.errors">\n' +
            '</div>',
        },
        middleName: {
          getScope: this.$scope,
          permissions: 'CUSTOMERS_UPDATE',
          template:
            '\n' +
            '<div data-input-field-with-label\n' +
            'class="customers-individuals-detail-input"\n' +
            'data-label="Middle Name"\n' +
            'data-name="customers-individuals-edit-middle-name"\n' +
            'data-field-name="customers-individuals-edit-middle-name"\n' +
            'type="text"\n' +
            'data-model="customersIndividualsDetail.customer.middleName"\n' +
            'data-errors="customersIndividualsDetail.errors">\n' +
            '</div>',
        },
        lastName: {
          getScope: this.$scope,
          permissions: 'CUSTOMERS_UPDATE',
          template:
            '\n' +
            '<div data-input-field-with-label\n' +
            'class="customers-individuals-detail-input"\n' +
            'data-label="Last Name"\n' +
            'data-name="customers-individuals-edit-last-name"\n' +
            'data-field-name="customers-individuals-edit-last-name"\n' +
            'type="text"\n' +
            'data-model="customersIndividualsDetail.customer.lastName"\n' +
            'data-required="true"\n' +
            'data-errors="customersIndividualsDetail.errors">\n' +
            '</div>',
        },
        email: {
          getScope: this.$scope,
          permissions: 'CUSTOMERS_UPDATE',
          template:
            '\n' +
            '<div data-input-field-with-label\n' +
            'class="customers-individuals-detail-input"\n' +
            'data-label="Email"\n' +
            'data-name="customers-individuals-edit-email"\n' +
            'data-field-name="customers-individuals-edit-email"\n' +
            'type="text"\n' +
            'data-model="customersIndividualsDetail.customer.email"\n' +
            'data-errors="customersIndividualsDetail.errors">\n' +
            '</div>',
        },
        phoneNumber: {
          getScope: this.$scope,
          permissions: 'CUSTOMERS_UPDATE',
          template:
            '\n' +
            '<div data-input-field-with-label\n' +
            'class="customers-individuals-detail-input"\n' +
            'data-label="Phone Number"\n' +
            'data-name="customers-individuals-edit-phone"\n' +
            'data-field-name="customers-individuals-edit-phone"\n' +
            'type="text"\n' +
            'data-model="customersIndividualsDetail.customer.phoneNumber"\n' +
            'data-errors="customersIndividualsDetail.errors">\n' +
            '</div>',
        },
      },
      hideTitles: ['prefix', 'suffix', 'firstName', 'middleName', 'lastName', 'email', 'phoneNumber', 'phoneNotes'],
    });

    this.addressGridOptions.columnDefs.unshift({
      field: 'edit',
      displayName: 'Edit',
      onCellNavClick: (row, col) => {
        this.addressGridOptions.appScopeProvider.onEditClick(row.entity);
      },
      cellTemplate:
        '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a class="clickable" data-ng-click="grid.appScope.onEditClick(row.entity)" role="button">Edit<span class="sr-only"> address</span></a></div>',
      enableHiding: false,
      enableSorting: false,
      width: 40,
    } as ColumnDef);
  }

  initMembershipGrid() {
    if (this.PermissionsService.check(['MEMBERSHIP_UPDATE'])) {
      this.membershipGridOptions.columnDefs.push({
        field: 'setAsLatest',
        displayName: 'Set as Latest',
        visible: true,
        onCellNavClick: (row, col) => {
          this.membershipGridOptions.appScopeProvider.onSetAsLatest(row.entity);
        },
        cellTemplate:
          '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a class="clickable" data-ng-show="row.entity.membershipStanding !== \'new\'" data-ng-click="grid.appScope.onSetAsLatest(row.entity)" role="button">Set <span class="sr-only">membership with ID {{ row.entity.id }} </span>as Latest</a></div>',
        enableHiding: false,
        enableSorting: false,
      } as ColumnDef);
    }
  }

  initFormsGrid() {
    if (this.PermissionsService.check('FORM_RESPONSE_VIEW')) {
      this.formsGridOptions.optionsOverride.columnDefs.unshift({
        field: 'View',
        headerName: 'View',
        width: 60,
        onCellNavClick: (row, col) => {
          this.formsGridOptions.optionsOverride.appScopeProvider.onGridDoubleClick(row);
        },
        cellTemplate:
          '<div class="clickable ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.onGridDoubleClick(row)" role="link">View<span class="sr-only"> Details</span></a></div>',
        enableHiding: false,
        enableSorting: false,
      });
    }
  }

  isEditMode() {
    return this.$state.current.name === 'application.customers.individuals.edit';
  }

  isTab(tab: CustomerIndividualDetailTab) {
    return this.tab === tab;
  }

  setTab(tab: CustomerIndividualDetailTab) {
    this.tab = tab;
    this.refreshGrids();
    this.loadTabData();
  }

  loadTabData() {
    switch (this.tab) {
      case 'forms': {
        switch (this.formsResponsesListStatus) {
          case 'initial': {
            this.formsResponsesListStatus = 'pending';
            this.apiService.orders.forms.responses
              .customer({ customerId: this.$stateParams.id })
              .then(extractACMEPayload())
              .then((response) => response.list)
              .catch(() => [] as CustomerFormResponse[])
              .then((response) => this.getFormsResponses(response))
              .then((processedFormResponses) => {
                this.formsResponsesList = processedFormResponses;
                this.formsResponsesListStatus = 'fulfilled';
                this.refreshFormGrid();
              });
            break;
          }

          case 'pending':
          case 'fulfilled': {
            // noop
            break;
          }
        }
        break;
      }

      default: {
        // noop
        break;
      }
    }
  }

  refreshGrids() {
    switch (this.tab) {
      case 'addresses':
        this.refreshAddressesGrid();
        break;

      case 'memberships':
        this.refreshMembershipsGrid();
        break;

      case 'mergeHistory':
        this.refreshMergeHistoryGrid();
        break;

      case 'forms':
        this.refreshFormGrid();
        break;

      default:
        // noop
        break;
    }
  }

  processMemberships(memberships) {
    const results: TODO = [];

    angular.forEach(memberships, (item) => {
      item.membershipJoinedDate = this.$filter('date')(
        this.CalendarService.parseDate(item.membershipJoinedDate),
        this.UserPreferencesService.getDateTimeFormat('sortDateTime')
      );
      item.membershipStartDate = this.$filter('date')(
        this.CalendarService.parseDate(item.membershipStartDate),
        this.UserPreferencesService.getDateTimeFormat('sortDateTime')
      );
      item.membershipExpirationDate = this.$filter('date')(
        this.CalendarService.parseDate(item.membershipExpirationDate),
        this.UserPreferencesService.getDateTimeFormat('sortDateTime')
      );

      item.isLatest = item.lastVersion ? 'Yes' : 'No';

      results.push(item);
    });

    return results;
  }

  createOrder() {
    // TODO: extract this logic to a reusable service
    // Call parent controller for this
    this.$scope.customersIndividuals.createOrder(this.model);
  }

  hasAddresses() {
    return Array.isArray(this.addresses) && this.addresses.length > 0;
  }

  getValidators() {
    const oneOf: TODO = this.getOneofValues();

    return [
      {
        field: 'customers-individuals-edit-first-name',
        len: { message: 'Invalid name', test: { value: this.customer.firstName } },
      },
      {
        field: 'customers-individuals-edit-last-name',
        len: { message: 'Invalid name', test: { value: this.customer.lastName } },
      },
      {
        field: 'customers-individuals-edit-email',
        optionalEmail: {
          message: 'Invalid email',
          test: () => {
            return this.customer.email;
          },
        },
      },
      {
        field: 'customers-individuals-edit-phone',
        optionalPhone: {
          message: 'Invalid phone number',
          test: () => {
            return this.customer.phoneNumber;
          },
        },
      },
    ].concat(oneOf);
  }

  getOneofValues() {
    const oneOfValues = [
      { value: this.customer.email },
      { value: this.customer.phoneNumber },
      { value: this.hasAddresses() },
    ];

    return [
      {
        field: 'customers-individuals-edit-email',
        oneOf: { message: 'Invalid email', test: { values: oneOfValues } },
      },
      {
        field: 'customers-individuals-edit-phone',
        oneOf: { message: 'Invalid phone number', test: { values: oneOfValues } },
      },
    ];
  }

  updateCustomer() {
    this.notice.hideErrorMessages();
    this.notice.hideSuccessMessages();

    this.loading = true;

    if (this.ValidateService.validate(this.getValidators())) {
      this.errors = {};
      this.customer.prefix = this.customer.selectedTitle?.title ?? '';

      this.customer.address = this.addresses;
      Object.assign(this.model, this.customer);

      this.apiService.customers
        .update(this.model)
        .then(() => {
          this.notice.showSuccessMessages([{ message: 'Successfully Updated!' }]);

          this.$timeout(() => {
            this.$state.go(
              'application.customers.individuals.detail',
              { id: this.$state.params.id },
              { location: 'replace' }
            );
          }, 3000);
        })
        .catch((response) => {
          this.notice.showErrorMessages([{ message: response.data.error }]);
        });
    } else {
      this.errors = this.ValidateService.getErrorHash();

      if (!this.ValidateService.validate(this.getOneofValues())) {
        this.notice.showErrorMessages([
          { message: 'To save a customer you must provide one of the following: Email, Phone, or Address' },
        ]);
      }
    }
  }

  fetchCustomer() {
    return this.apiService.customers
      .detail({
        customerId: this.$state.params.id,
        includeAssociatedMemberships: true,
        includeMergeHistory: true,
      })
      .then(extractACMEPayload());
  }

  getCustomer() {
    this.loading = true;
    if (this.$state.params) {
      this.initHeader({ loading: true });

      this.fetchCustomer()
        .then((customer) => {
          this.lookForDuplicates(customer);

          this.model = this.processModel(customer);
          this.customer = Object.assign({}, this.process(customer));

          this.addresses = this.model.address;
          this.memberships = this.processMemberships(this.model.memberships).sort((a, b) => b.id - a.id);
          this.attributes = this.model.attributes;
          this.solicitationCodes = this.model.solicitationCodes;

          if (this.isTab('')) {
            if (this.hasAddresses() || this.isEditMode()) {
              this.setTab('addresses');
            } else if (this.hasMemberships()) {
              this.setTab('memberships');
            } else if (this.hasAttributes()) {
              this.setTab('attributes');
            } else if (this.hasSolicitationCodes()) {
              this.setTab('solicitationCodes');
            } else if (this.hasMergeHistory()) {
              this.setTab('mergeHistory');
            } else if (this.hasForms()) {
              this.setTab('forms');
            }
          } else {
            this.refreshGrids();
          }
        })
        .catch((response) => {
          this.notice.showErrorMessages([{ message: response.data.error }]);
        })
        .finally(() => {
          this.loading = false;
          this.initHeader({ loading: false });
        });
    }
  }

  lookForDuplicates(customer: Customer) {
    const rawFilters = rawFiltersSchema.safeParse(customer);

    if (!this.enableCustomerMerge || rawFilters.success === false) {
      return this.$q.resolve({
        success: true,
        payload: {
          list: [],
          pagination: {
            count: 0,
            page: 1,
            pageSize: 0,
            sortDirection: 'desc',
            sortField: 'createdOn',
          },
        },
      } satisfies ACMEListResponse<Customer>);
    }

    return this.customersIndividualsListService
      .queryWithAdvancedSearch({
        pageSize: 50,
        page: 1,
        sortField: 'createdOn',
        sortDirection: 'desc',
        rawFilters: rawFilters.data,
      })
      .then((response) => {
        this.possiblyDuplicateCustomers = response.payload.list.filter((item) => item.id !== customer.id);

        return response;
      });
  }

  reviewPotentialMatches() {
    this.customersIndividualsListService.setAdvancedSearchState({
      lastName: this.customer.lastName,
      email: this.customer.email,
    });

    this.$state.go('application.customers.individuals.list');
  }

  showCancelModal() {
    this.cancelModal = this.$uibModal.open({
      size: 'sm',
      controller: 'ConfirmModalController',
      templateUrl: 'common/views/modals/confirm/confirm.tpl.html',
      resolve: {
        modalTitle: () => 'Are you sure?',
        okText: () => 'Continue',
        modalMessage: () => 'No changes will be saved.',
      },
    });

    this.cancelModal.result.then(() => {
      this.$state.go(
        'application.customers.individuals.detail',
        { id: this.$state.params.id },
        { location: 'replace' }
      );
    });
  }

  addAddress() {
    this.editAddress();
  }

  editAddress(address?: TODO) {
    const editAddressModal: UIBModal<TODO> = this.$uibModal.open({
      templateUrl: 'views/application/views/partners/create/modals/CreateEditCustomerAddressModal.tpl.html',
      size: 'md',
      backdrop: 'static',
      controller: 'CreateEditAddressModalController',
      resolve: {
        organizationId: () => this.$state.params.accountId,
        address: () => address || null,
        preventSave: () => true,
      },
    });

    editAddressModal.result.then((address: TODO) => {
      if (address.id) {
        this.addresses.forEach((item: TODO) => {
          if (item.id === address.id) {
            Object.assign(item, address);
          }
        });
      } else {
        if (!this.addresses.length) {
          Object.assign(address, {
            type: 'primary',
            isPrimary: true,
          });
        }

        this.addresses.push(address);
      }

      this.refreshAddressesGrid();
    });
  }

  hasSolicitationCodes() {
    return Array.isArray(this.model.solicitationCodes) && this.model.solicitationCodes.length > 0;
  }

  hasMemberships() {
    return Array.isArray(this.model.memberships) && this.model.memberships.length > 0;
  }

  hasForms() {
    return Array.isArray(this.formsResponsesList) && this.formsResponsesList.length > 0;
  }

  hasAttributes() {
    return Array.isArray(this.model.attributes) && this.model.attributes.length > 0;
  }

  hasMergeHistory() {
    return Array.isArray(this.customer.mergeHistory) && this.customer.mergeHistory.length > 0;
  }

  process(customer: Customer): Customer & { selectedTitle?: { title: string; name: string } } {
    return {
      ...customer,
      prefix: customer.prefix || '',
      suffix: customer.suffix || '',
      middleName: customer.middleName || '',
      phoneNotes: customer.phoneNotes || '',
      selectedTitle: this.customerService.findSalutation(customer.prefix || ''),
      mergeHistory: customer.mergeHistory ?? [],
    };
  }

  processModel(model: TODO) {
    return {
      ...model,
      createdOn: this.$filter('date')(this.CalendarService.parseDate(model.createdOn), this.dateTimeFormat),
      updatedOn: this.$filter('date')(this.CalendarService.parseDate(model.updatedOn), this.dateTimeFormat),
      createdBy:
        model.createdBy && this.PermissionsService.check('USERS_VIEW')
          ? parseUrl(this.$state.href('application.users.detail', { id: model.createdBy }), model.createdBy)
          : null,
      updatedBy:
        model.updatedBy && this.PermissionsService.check('USERS_VIEW')
          ? parseUrl(this.$state.href('application.users.detail', { id: model.updatedBy }), model.updatedBy)
          : null,
    };
  }

  getFormsResponses(formsList: CustomerFormResponse[]) {
    return this.customersIndividualsDetailService
      .getFormMetaData(formsList)
      .then((membershipData) => this.processFormsList(formsList, membershipData));
  }

  processFormsList(formsList: CustomerFormResponse[], membershipsData: TODO) {
    const formsSummariesListItemList = formsList.map((item) => {
      switch (item.formCategoryType) {
        case 'membership': {
          return {
            ...item,
            itemName: '',
            membershipLifecycle: this.customersIndividualsDetailService.getMembershipLifecycle(item.itemType),
            ...(item.membershipId
              ? {
                  membershipId: item.membershipId,
                  membershipLevel: membershipsData[item.membershipId].membershipLevel,
                  membershipOffering: membershipsData[item.membershipId].membershipOffering,
                }
              : {}),
          };
        }

        case 'event':
        case 'donation':
        case 'addon':
        default: {
          return item;
        }
      }
    });

    return formsSummariesListItemList;
  }

  refreshAddressesGrid() {
    const totalItems = this.addresses ? this.addresses.length : 0;
    this.addressGridDefinition.isLoaded = true;

    this.$timeout(() => {
      this.$scope.$broadcast('DataGrid::ResizeGrid', {
        name: this.addressGridDefinition.options.gridName,
        datasetLength: totalItems,
        totalItems: totalItems,
      });
    }, 10);
  }

  refreshMembershipsGrid() {
    const totalItems = this.memberships ? this.memberships.length : 0;
    this.membershipGridDefinition.isLoaded = true;

    this.$timeout(() => {
      this.$scope.$broadcast('DataGrid::ResizeGrid', {
        name: this.membershipGridDefinition.options.gridName,
        datasetLength: totalItems,
        totalItems: totalItems,
      });
    }, 10);
  }

  refreshMergeHistoryGrid() {
    const totalItems = this.customer.mergeHistory ? this.customer.mergeHistory.length : 0;
    this.mergeHistoryGridDefinition.isLoaded = true;

    this.$timeout(() => {
      this.$scope.$broadcast('DataGrid::ResizeGrid', {
        name: this.mergeHistoryGridDefinition.options.gridName,
        datasetLength: totalItems,
        totalItems: totalItems,
      });
    }, 10);
  }

  refreshFormGrid() {
    const totalItems = this.formsResponsesList ? this.formsResponsesList.length : 0;
    this.formsGridDefinition.isLoaded = true;
    this.$timeout(() => {
      this.$scope.$broadcast('DataGrid::ResizeGrid', {
        name: this.formsGridDefinition.options.gridName,
        datasetLength: totalItems,
        totalItems: totalItems,
      });
    }, 10);
  }

  onSetAsLatest(item) {
    if (item.membershipStanding !== 'new') {
      this.notice.hideErrorMessages();
      this.notice.hideSuccessMessages();

      this.isMembershipLoading = true;

      this.apiService.membership.versions
        .setLatest(item.id)
        .then((response) => {
          this.notice.showSuccessMessages([{ message: 'Membership Updated!' }]);

          this.getCustomer();
          this.isMembershipLoading = false;

          this.$timeout(() => {
            this.notice.hideSuccessMessages();
          }, 3000);
        })
        .catch((response) => {
          this.notice.showErrorMessages([{ message: response.data.error }]);

          this.isMembershipLoading = false;

          this.$timeout(() => {
            this.notice.hideErrorMessages();
          }, 3000);
        });
    }
  }

  onIdClick(item) {
    this.$state.go('application.membership.detail', { id: item.id });
  }
}

export const CustomersIndividualsDetailComponentModule = angular
  .module('acme.view.application.customers.individuals.detail.controllers', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.service.permissions',
    'acme.common.service.themesHelper',
    'acme.common.service.calendar',
    CustomerServiceModule,
    'acme.common.service.userPreferences',
    'acme.common.service.validate',
    'acme.common.factory.notice',
    'acme.common.factory.gridState',
    'acme.common.factory.gridDefinition',
    'acme.common.service.helpers',
    CustomersIndividualsListServiceModule,
    CustomersIndividualsDetailServiceModule,
    AlertComponentModule,
    NoticesComponentModule,
  ])
  .component('acmeCustomersIndividualsDetail', {
    templateUrl: 'views/application/views/customers/individuals/detail/detail.tpl.html',
    controller: CustomersIndividualsDetailController,
    bindings: {
      ThemesData: '<',
    },
  }).name;
